import React from 'react';
import { CheckCircle2, PauseCircle, Ban, Trash2 } from 'lucide-react';

/**
 * Visual status pill for a customer row.
 *
 *   active     → green   (CheckCircle2)
 *   suspended  → amber   (PauseCircle)
 *   banned     → red     (Ban)
 *   deleted    → grey    (Trash2)
 *
 * Defaults to "active" so legacy rows without a `status` field still render.
 */
const STYLES = {
  active:    { color: '#4ADE80', bg: 'rgba(74,222,128,0.10)', border: 'rgba(74,222,128,0.30)', icon: CheckCircle2, label: 'Active' },
  suspended: { color: '#FBB924', bg: 'rgba(251,185,36,0.10)', border: 'rgba(251,185,36,0.30)', icon: PauseCircle,  label: 'Suspended' },
  banned:    { color: '#FF6B6B', bg: 'rgba(255,107,107,0.10)', border: 'rgba(255,107,107,0.35)', icon: Ban,         label: 'Banned' },
  deleted:   { color: '#7A7A7A', bg: 'rgba(122,122,122,0.10)', border: 'rgba(122,122,122,0.30)', icon: Trash2,       label: 'Deleted' },
};

export default function CustomerStatusBadge({ status = 'active', size = 'sm' }) {
  const s = STYLES[status] || STYLES.active;
  const Icon = s.icon;
  const sizing = size === 'lg'
    ? 'text-sm px-3 py-1 gap-1.5'
    : 'text-[11px] px-2 py-0.5 gap-1';

  return (
    <span
      data-testid={`customer-status-${status}`}
      className={`inline-flex items-center rounded-full border ${sizing}`}
      style={{ color: s.color, background: s.bg, borderColor: s.border }}
    >
      <Icon size={size === 'lg' ? 13 : 10}/>
      {s.label}
    </span>
  );
}
